import "./ErrorPage.css";
import React from "react";
import {
	Card,
	CardContent,
	Typography,
	Icon,
	Link,
} from "../../common/MaterialComponent";
import { useGetComponentStringsContext } from "../../hooks/useGetComponentStrings";

interface ErrorPageProps {
	message: string;
}

export const ErrorPage: React.FC<ErrorPageProps> = ({ message }) => {
	const strings = useGetComponentStringsContext().ErrorPage;

	const refreshPage = () => {
		window.location.reload();
	};

	return (
		<>
			<Card>
				<CardContent className="errorCardContent">
					<Icon color="error" className="warningIcon">
						warning
					</Icon>
					<Typography noWrap>
						<span className="warningText">{message}</span>
						<br />
						<span className="warningText">
							<Link
								component="button"
								variant="body2"
								onClick={refreshPage}
								className="linkText"
								color="primary"
							>
								{strings.refreshLinkMessage}
							</Link>
						</span>
					</Typography>
				</CardContent>
			</Card>
		</>
	);
};
